export const locale = {
  lang: 'en',
  data: {
    PAGINATION: {
      ITEM_PER_PAGE: 'Items per page',
      OF: 'of'
    }
  }
};
